import React from 'react';

type Props = {
  currentUrl?: string;
};

export const getLiveSiteUrl = (currentUrl: string): string | null => {
  const url = new URL(currentUrl);
  const preprodPrefix = 'preprod.';

  if (!url.hostname.toLowerCase().startsWith(preprodPrefix)) {
    return null;
  }

  url.hostname = url.hostname.slice(preprodPrefix.length);
  return url.toString();
};

export default function PreprodTestSiteBanner({ currentUrl = window.location.href }: Props) {
  const liveSiteUrl = getLiveSiteUrl(currentUrl);
  const headingId = React.useId();

  if (!liveSiteUrl) {
    return null;
  }

  return (
    <section
      className="govuk-notification-banner govuk-notification-banner--error"
      aria-labelledby={headingId}
      data-testid="preprod-test-site-banner"
    >
      <div className="govuk-notification-banner__header">
        <h2 className="govuk-notification-banner__title" id={headingId}>
          TEST SITE
        </h2>
      </div>
      <div className="govuk-notification-banner__content">
        <p className="govuk-body">
          This is a test site, if you are not a tester, please click the below link to goto the
          correct form
        </p>
        <p className="govuk-body govuk-!-margin-bottom-0">
          <a className="govuk-link" href={liveSiteUrl}>
            {liveSiteUrl}
          </a>
        </p>
      </div>
    </section>
  );
}
